import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SsoAuthService } from '../../ecan/sso-auth.service';
import { AppConfigurationService } from '../../stp/stp-app/common';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public authError: string;
  private reauthPromise: Promise<unknown>;
  private sessionExpiredMustLogIn = 'Your session has expired so you need to log in again. If you have unsaved changes, you can open another window and log in, then come back to this window and try saving again.';

  constructor(private router: Router,
    private ssoAuthService: SsoAuthService,
    private appConfig: AppConfigurationService) {
  }

  public lastAuthentictionError: any;

  public init() {
    this.ssoAuthService.configure({
      namespace: this.appConfig.getValue('auth0Namespace'),
      clientID: this.appConfig.getValue('auth0ClientID'),
      domain: this.appConfig.getValue('auth0Domain'),
      audience: this.appConfig.getValue('auth0Audience'),
      callbackUrl: this.appConfig.getValue('webUrl') + '/callback'
    });

    this.ssoAuthService.registerEventCallback('renewtokenfailed', () => {
      console.log('renew token failed');
      alert('Your session has expired. Please reload the page and login.');
      this.authError = this.sessionExpiredMustLogIn;
    });
    this.ssoAuthService.registerEventCallback('usersessionchanged', () => {
      // notify the user and reload the page to ensure they have the correct state
      alert('The identity of your session has changed');
      this.authError = 'The identity of your session has changed. Please reload the page.';
      this.ssoAuthService.refreshToken(true);
    });
  }

  public tryImplicitOrRequireLogin(): Promise<unknown> {

    if (!!this.reauthPromise) {
      return this.reauthPromise;
    }

    if (this.ssoAuthService.isAuthenticated()) {
      this.reauthPromise = this.ssoAuthService.refreshToken(true);
      this.reauthPromise.then(() => this.ssoAuthService.getCurrentUser());
    } else {
      // user is not currently authenticated so we want to check with Auth0 if the signed on and get a new token.
      this.reauthPromise = this.ssoAuthService.checkSSO();
    }

    this.reauthPromise.then(
      (authResult) => {
        this.handleAuthenticationError(authResult);
        this.reauthPromise = null;
      },
      (err) => {
        this.handleAuthenticationError(err);
        this.reauthPromise = null;
      }
    );

    return this.reauthPromise;
  }

  public handleAuthenticationError(error) {
    if (error && error.isError && error.code) {
      console.warn('Authentication failed. Code: ' + error.code + '. Description: ' + error.description);
      this.lastAuthentictionError = error;

      switch (error.code) {
        case 'email':
          this.ssoAuthService.localLogout();
          this.router.navigate(['/emailrequired']);
          break;
        case 'email_verified':
          this.ssoAuthService.localLogout();
          this.router.navigate(['/accountnotactivated']);
          break;
        case 'login_required':
          this.authError = this.sessionExpiredMustLogIn;
          break;
        default:
          this.ssoAuthService.localLogout();
          this.router.navigate(['/authenticationerror']);
      }
    }
  }
}
